import type { WizardStep } from '../../components/BbStepper'

/* The four steps of the modify flow, matching the export wizard's shape:
   pick what to change, narrow it down, edit the real records, then submit. */
export const MODIFY_STEPS: WizardStep[] = [
  { key: 'type', label: 'Record Type' },
  { key: 'filters', label: 'Filters' },
  { key: 'edit', label: 'Edit Records' },
  { key: 'save', label: 'Save' },
]
